import { render } from "./ReportPostModal.vue?vue&type=template&id=0541f7d2"
import script from "./ReportPostModal.vue?vue&type=script&lang=js"
export * from "./ReportPostModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/ReportPostModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0541f7d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0541f7d2', __exports__)) {
    api.reload('0541f7d2', __exports__)
  }
  
  module.hot.accept("./ReportPostModal.vue?vue&type=template&id=0541f7d2", () => {
    api.rerender('0541f7d2', render)
  })

}


export default __exports__